import { link } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'
import { imageOrVideoFields, richTextFields } from '@/data/sanity/fragments/_shared'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title,
  description[]{${richTextFields}},
  linkList[]{${link.fields}},
  media{${imageOrVideoFields}}
`

export const fragment = (name = 'servicesHero') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
